import React from 'react';
import { useSearchParams } from "react-router-dom";
import { queryParams } from "../../helpers/UrlHelpers";

import { Pagination as PaginationAntd } from "antd";
import './style.scss';

export interface PaginationInterface {
  total: number;
  size?: number;
  className?: string;
  align?: 'right' | 'left' | 'center';
}

const Pagination = ({ className, align, total, size = 40 }: PaginationInterface) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const page                            = queryParams.getInt(searchParams,'page') || 1;

  let extraClassName                    = className || '';
  extraClassName                        += align ? ` o-${align}` : '';

  const onChangePagination = (page: number) => {
    searchParams.set('page', page.toString());
    setSearchParams(searchParams, { replace: true });
  }

  return (
    <div className={`v-pagination ${extraClassName}`}>
      <PaginationAntd
        current={page}
        total={total}
        hideOnSinglePage={true}
        defaultPageSize={size}
        showSizeChanger={false}
        onChange={onChangePagination}
      />
    </div>
  )
}

export default Pagination;
